export default __webpack_public_path__ + "static/media/cloud1.5f0d4ede.svg";